import { actionType } from './actions';

const initialState = {
    addNewProspectusData: {
        name: '',
        prospectusDate: ''
    },
    editProspectusData: {
        prospectusId: '',
        name: '',
        prospectusDate: ''
    },
    viewProspectusData: {
        prospectusId: '',
        name: '',
        prospectusDate: ''
    },
    selectedHistoryItem: {},
    prospectusList: [],
    filings: [],
    history: [],
    searchString: '',
    selectedItemData: {},
    isGridItemSelected: false,
    editProspectusVisibility: false,
    viewProspectusVisibility: false,
    fetching: false,
    fetched: false,
    error: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.REQUESTED_PROSPECTUS_DATA: {
            return {
                ...state,
                fetching: true,
                fetched: false,
                error: false
            };
        }

        case actionType.ADD_NEW_PROSPECTUS:
        case actionType.EDIT_PROSPECTUS: {
            return {
                ...state,
                prospectusList: state.prospectusList.map(prospectus => {
                    if (prospectus.prospectusId === action.payload.prospectusId) {
                        return action.payload;
                    }
                    return prospectus;
                }),
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.REJECTED_PROSPECTUS_DATA: {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: true
            };
        }

        case actionType.FETCH_PROSPECTUS_DATA: {
            return {
                ...state,
                editProspectusData: action.payload,
                viewProspectusData: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_PROSPECTUS_FILINGS: {
            return {
                ...state,
                filings: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_PROSPECTUS_HISTORY: {
            return {
                ...state,
                history: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_PROSPECTUS_BY_CLIENT: {
            return {
                ...state,
                prospectusList: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.SEARCH_PROSPECTUS_BY_KEYWORD: {
            return {
                ...state,
                prospectuss: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.UPDATE_PROSPECTUS_SELECTED: {
            return {
                ...state,
                selectedItemData: action.payload
            };
        }

        case actionType.UPDATE_SEARCH_STRING: {
            return {
                ...state,
                searchString: action.payload
            };
        }

        case actionType.UPDATE_ADD_NEW_PROSPECTUS_PAYLOAD: {
            return {
                ...state,
                addNewProspectusData: action.payload
            };
        }

        case actionType.UPDATE_EDIT_PROSPECTUS_PAYLOAD: {
            return {
                ...state,
                editProspectusData: action.payload
            };
        }

        case actionType.UPDATE_PROSPECTUS_HISTORY_ITEM_SELECTED: {
            return {
                ...state,
                selectedHistoryItem: action.payload
            };
        }

        case actionType.HANDLE_EDIT_PROSPECTUS_VISIBILITY: {
            return {
                ...state,
                editProspectusVisibility: action.visibility
            };
        }

        case actionType.HANDLE_VIEW_PROSPECTUS_VISIBILITY: {
            return {
                ...state,
                viewProspectusVisibility: action.visibility
            };
        }

        case actionType.CLEAR_PROSPECTUSES_LIST: {
            return {
                ...state,
                prospectusList: []
            };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/services/redux/employee/prospectus/reducers.js